(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6352],{

/***/ 26693:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/close-white.d3f1a0ed.svg","height":17,"width":17});

/***/ }),

/***/ 55619:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/modal-close.5d34d298.svg","height":29,"width":28});

/***/ }),

/***/ 30167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B8": function() { return /* binding */ getStoreEventInfo; },
/* harmony export */   "CS": function() { return /* binding */ zipCodeInfoModalContinueAnalytics; },
/* harmony export */   "DO": function() { return /* binding */ addFindAStoreAnalytics; },
/* harmony export */   "HS": function() { return /* binding */ locationMessageNavigationAnalytics; },
/* harmony export */   "LX": function() { return /* binding */ setStoreAnalytics; },
/* harmony export */   "OQ": function() { return /* binding */ addAnalyticsData; },
/* harmony export */   "Qq": function() { return /* binding */ pushAnalyticsToDataLayer; },
/* harmony export */   "Us": function() { return /* binding */ getFilterEventInfo; },
/* harmony export */   "X1": function() { return /* binding */ addAnalyticsEvent; },
/* harmony export */   "dm": function() { return /* binding */ getEventClearFilterInfo; },
/* harmony export */   "hE": function() { return /* binding */ getEventStoreFilterInfo; },
/* harmony export */   "pm": function() { return /* binding */ findAStoreLoadMoreAnalytics; },
/* harmony export */   "rt": function() { return /* binding */ getEventStorePhoneInfo; },
/* harmony export */   "wo": function() { return /* binding */ addFilterExpandCollapseAnalytics; }
/* harmony export */ });
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);

const pageType = "find a store";
const addFindAStoreAnalytics = (params)=>{
    const { total , errorMessage , status , action , authorData , staticTexts , searchTerm , geolocationEvent  } = params;
    const errMsg = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.sanitizeText)(authorData.locationErrormessage ? authorData.locationErrormessage : staticTexts.locationErrormessage).trim().toLowerCase();
    let eventAction = "find a store:landing:location info:store search";
    let eventName = "find a store:landing:location info:store search";
    const eventStatus = status === "success" && total ? "success" : "failure";
    let internalLinkName = "store search";
    let internalLinkZoneName = "find a store:landing:location info:filters";
    if (geolocationEvent) {
        eventAction = "find a store:utility nav​:view store details:use my location";
        eventName = "find a store:utility nav​:view store details:use my location";
        internalLinkName = "use my location";
        internalLinkZoneName = "find a store:utility nav";
    }
    const currDate = new Date();
    const eventInfo = {
        searchCount: sessionStorage.getItem("findStores") ? Number(sessionStorage.getItem("findStores")) + 1 : 1,
        searchResult: total,
        internalLinkName,
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:navigation",
        searchType: isNaN(searchTerm) || geolocationEvent ? "location" : "zipcode",
        searchTerm: searchTerm,
        eventAction,
        eventName,
        eventType: "navigation",
        clickInternalLinks: "true",
        internalLinkURL: "".concat(window.location.origin).concat(window.location.pathname),
        internalLinkZoneName,
        eventMsg: status === "success" && total ? "n/a" : errorMessage || errMsg || "n/a",
        eventStatus,
        pageName: "find a store result",
        pageURL: window.location.href,
        referrer: document.referrer || "n/a",
        previousPage: document.referrer || "n/a",
        timeStamp: currDate.toISOString().split("T")[0] + " " + currDate.toTimeString().split(" ")[0]
    };
    if (action === "cmp:show" && !(0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.isShowAnalyticsEventLoaded)() || action !== "cmp:show") {
        sessionStorage.setItem("findStores", eventInfo.searchCount);
        const { adobeDataLayer: { getState  } = {}  } = window;
        const event = !(0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.isShowAnalyticsEventLoaded)() ? "cmp:show" : action;
        const page = event === "cmp:show" ? window.pageObj : getState && getState("page") || {};
        if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.navigationType)() !== 1 && event === "cmp:show" || event === "cmp:click") {
            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo, event, page);
        }
        delete window.pageObj;
    }
};
const findAStoreLoadMoreAnalytics = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "find a store:landing:location info:load more results",
        eventMsg: "n/a",
        eventName: "find a store:landing:location info:load more results",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "load more results",
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:load more results",
        internalLinkURL: "".concat(window.location.origin).concat(window.location.pathname),
        internalLinkZoneName: "find a store:landing:location info"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo);
};
const getFilterEventInfo = (showFilter)=>{
    const type = showFilter ? "show filter" : "hide filter";
    const internalLinkType = "find a store:".concat(showFilter ? "show" : "hide");
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "find a store:landing:location info:".concat(type),
        eventName: "find a store:landing:location info:".concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(type, "s"),
        internalLinkPosition: "find a store",
        internalLinkType,
        internalLinkURL: "".concat(window.location.origin).concat(window.location.pathname),
        internalLinkZoneName: "find a store:landing:filters"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo);
};
const getStoreEventInfo = (type, internalLinkName, link)=>{
    return JSON.stringify({
        eventAction: "find a store:landing:location info:" + type,
        eventName: "find a store:landing:location info:" + type,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: internalLinkName ? internalLinkName.toLowerCase() : type,
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:navigation",
        internalLinkZoneName: "find a store:landing:location info",
        internalLinkURL: link ? (link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a",
        clickInternalLinks: "true"
    });
};
const getEventStoreFilterInfo = (data, type, link)=>{
    let internalLinkName;
    let internalLinkType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.sanitizeTextForAnalytics)(data.LocationName);
    const internalLinkTypeForFindStore = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.getInternalLinkTypeForFindStore)(data.LocationName, data.Locality, data.StateLong);
    if (type === "store name") {
        internalLinkName = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.sanitizeTextForAnalytics)(data.LocationName);
        internalLinkType = "find a store:".concat(internalLinkTypeForFindStore);
    } else if (type === "store contact number") {
        internalLinkName = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.formatPhoneNumber)(data.Phone);
        internalLinkType = "find a store:navigation";
    } else if (type === "set as preferred store" || type === "unset as preferred store") {
        internalLinkType = "find a store:".concat(internalLinkTypeForFindStore);
    }
    return JSON.stringify({
        eventAction: "find a store:landing:location info:".concat(type),
        eventName: "find a store:landing:location info:".concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: internalLinkName || type,
        internalLinkPosition: "find a store",
        internalLinkType,
        internalLinkZoneName: "find a store:landing:location info​",
        internalLinkURL: link ? (type !== "store contact number" && link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a",
        clickInternalLinks: "true"
    });
};
const getEventStorePhoneInfo = (PhoneNumber, tabTitle, link)=>{
    const internalLinkPhoneType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.formatPhoneNumber)(PhoneNumber);
    const eventInfo = {
        eventAction: "find a store:landing:location info:".concat(internalLinkPhoneType),
        eventName: "find a store:landing:location info:".concat(internalLinkPhoneType),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: internalLinkPhoneType,
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:".concat(tabTitle === null || tabTitle === void 0 ? void 0 : tabTitle.toLowerCase()),
        internalLinkZoneName: "find a store:landing:location info​",
        internalLinkURL: internalLinkPhoneType === null ? link || "n/a" : "tel:".concat(PhoneNumber),
        clickInternalLinks: "true"
    };
    window === null || window === void 0 ? void 0 : window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo
    });
};
const addAnalyticsData = (curFilters, isChecked, obj, isFilterCancel)=>{
    const { facet , value: label  } = obj;
    const filterLabel = label || obj.display;
    const appliedOrRemoved = isFilterCancel ? "cancel" : isChecked ? "applied" : "removed";
    const eventInfo = {
        eventAction: "find a store:landing:filters:".concat(appliedOrRemoved),
        eventName: "find a store:landing:filters:".concat(appliedOrRemoved),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(filterLabel === null || filterLabel === void 0 ? void 0 : filterLabel.toLowerCase(), ":").concat(appliedOrRemoved),
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:".concat(facet === null || facet === void 0 ? void 0 : facet.toLowerCase()),
        filterArray: "".concat((facet === null || facet === void 0 ? void 0 : facet.toLowerCase()) + ":" + (filterLabel === null || filterLabel === void 0 ? void 0 : filterLabel.toLowerCase())),
        internalLinkZoneName: "find a store:landing:filters",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    let filterArray = "";
    if (curFilters.length > 0) {
        curFilters.forEach((facetObj)=>{
            facetObj.value.forEach((facetValue)=>{
                filterArray += facetObj.facet.toLowerCase() + ":" + facetValue.toLowerCase() + "|";
            });
        });
    }
    eventInfo.filterArray = filterArray === null || filterArray === void 0 ? void 0 : filterArray.slice(0, -1);
    if (window.adobeDataLayer) {
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page
        });
    }
};
const addFilterExpandCollapseAnalytics = (facet, formatFacetName, collapse)=>{
    const collapseOrExpand = collapse[facet] ? "expand" : "collapse";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "find a store:landing:filters:".concat(collapseOrExpand),
        eventName: "find a store:landing:filters:".concat(collapseOrExpand),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(collapseOrExpand),
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:".concat(formatFacetName === null || formatFacetName === void 0 ? void 0 : formatFacetName.toLowerCase()),
        internalLinkURL: "n/a",
        internalLinkZoneName: "find a store:landing:filters​"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo);
};
const getEventClearFilterInfo = ()=>{
    return JSON.stringify({
        eventAction: "find a store:landing:filters:clear all",
        eventName: "find a store:landing:filters:clear all",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "clear all",
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:filters",
        internalLinkZoneName: "find a store:landing:filters",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};
const addAnalyticsEvent = function(action) {
    let isForLocateMe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const type = isForLocateMe ? "" : "zoom ";
    const linkType = isForLocateMe ? "navigation" : "zoom";
    const eventInfo = {
        eventAction: "find a store:landing:map:".concat(type).concat(action),
        eventName: "find a store:landing:map:".concat(type).concat(action),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(type).concat(action),
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:".concat(linkType),
        internalLinkZoneName: "find a store:landing:map",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const setStoreAnalytics = (checked, locationName)=>{
    const type = checked ? "set as preferred store" : "unset as preferred store";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "find a store:landing:location info:".concat(type),
        eventMsg: "n/a",
        eventName: "find a store:landing:location info:".concat(type),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: type,
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:".concat(locationName === null || locationName === void 0 ? void 0 : locationName.toLowerCase()),
        internalLinkURL: "".concat(window.location.origin).concat(window.location.pathname),
        internalLinkZoneName: "find a store:landing:location info"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo);
};
const zipCodeInfoModalContinueAnalytics = (ctaLabel, dataLayerPosition)=>{
    const label = ctaLabel === null || ctaLabel === void 0 ? void 0 : ctaLabel.toLowerCase();
    let eventName = "find a store:utility nav:view store details:".concat(label);
    let internalLinkPosition = "find a store";
    let internalLinkType = "find a store:navigation";
    let internalLinkZoneName = "find a store:modal:cant access your location";
    if (dataLayerPosition === "global header") {
        eventName = "find a store:utility nav:use my location:".concat(label);
        internalLinkPosition = "global header:find a store";
    }
    if (dataLayerPosition === "find a pro") {
        eventName = "find a pro:see local professionals:use my location:".concat(label);
        internalLinkPosition = "find a pro";
        internalLinkType = "find a pro:use my location";
        internalLinkZoneName = "find a pro:see local professionals";
    }
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: eventName,
        eventMsg: "n/a",
        eventName,
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "".concat(label),
        internalLinkPosition,
        internalLinkType,
        internalLinkURL: "".concat(window.location.origin).concat(window.location.pathname),
        internalLinkZoneName
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo);
};
const locationMessageNavigationAnalytics = (param)=>{
    let { link ="" , label ="" , zone =""  } = param;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(zone, ":").concat(label),
        eventMsg: "n/a",
        eventName: "".concat(pageType, ":").concat(zone, ":").concat(label),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: label,
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":navigation"),
        internalLinkURL: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.getAnalyticsUrl)(link),
        internalLinkZoneName: "".concat(pageType, ":").concat(zone)
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo);
};
const pushAnalyticsToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const page = window.pageObj || {};
    const event = "cmp:click";
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page
    });
};


/***/ }),

/***/ 78145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Modal_Modal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
;// CONCATENATED MODULE: ./components/core/FindingModelNumber/v1/analyticsEventType.js
const getEventFor = (type)=>{
    if (type === null || type === void 0 ? void 0 : type.subCategory1.includes("support:contact")) {
        return "support:contact:form";
    }
    if (type === null || type === void 0 ? void 0 : type.subCategory1.includes("support:find a service part")) {
        return "support:find-a-service-part";
    }
    if (type === null || type === void 0 ? void 0 : type.subCategory1.includes("my account:product registration")) {
        return "my account:register offline kohler products:product information";
    }
    var ref;
    return (ref = type === null || type === void 0 ? void 0 : type.subCategory1) !== null && ref !== void 0 ? ref : "";
};


// EXTERNAL MODULE: ./public/icons/close-white.svg
var close_white = __webpack_require__(26693);
// EXTERNAL MODULE: ./public/icons/modal-close.svg
var modal_close = __webpack_require__(55619);
// EXTERNAL MODULE: ./components/core/Modal/Modal.module.scss
var Modal_module = __webpack_require__(43106);
var Modal_module_default = /*#__PURE__*/__webpack_require__.n(Modal_module);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./components/core/Modal/Modal.jsx









const Modal = (props)=>{
    const modalWindow = (0,react.useRef)(null);
    const [isRendered, setIsRendered] = (0,react.useState)(false);
    const [width, height] = (0,useWindowResize/* default */.Z)();
    const [style, setStyle] = (0,react.useState)({});
    const { className , children , showModal , modalTitle , labelledBy , describedBy , onModalClose , prevActiveElem , hideCloseIcon , closeButtonAnalytics , analyticsCustomData , needAnalyticsOnContentsLink , dataLayer , StickCloseButton , isWhiteCloseIcon =false , isCloseButtonClicked =()=>{}  } = props;
    const waitingTImeForModalContentToLoad = 500;
    const triggerModalClose = (e)=>{
        (0,helper.preventBodyScroll)(false);
        isCloseButtonClicked();
        onModalClose(e);
    };
    const handleKeyPress = (e)=>{
        const focusElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        const focusContent = modalWindow.current.querySelectorAll(focusElements);
        const firstElem = focusContent[0];
        const lastElem = focusContent[focusContent.length - 1];
        if (e.key === "Escape") {
            triggerModalClose();
        }
        if (e.key === "Tab") {
            if (e.shiftKey && (document.activeElement === firstElem || document.activeElement === modalWindow.current)) {
                e.preventDefault();
                lastElem.focus();
            }
            if (!e.shiftKey && document.activeElement === lastElem) {
                e.preventDefault();
                firstElem.focus();
            }
        }
    };
    (0,react.useEffect)(()=>{
        if (width < 577 || lib/* isIOS */.gn && width < 992) {
            setStyle({
                style: {
                    height: height,
                    minHeight: height
                }
            });
        } else {
            setStyle({});
        }
    }, [
        width,
        height
    ]);
    (0,react.useEffect)(()=>{
        if (showModal) {
            (0,helper.removeMavenoidChat)();
            if (!isRendered) {
                setIsRendered(true);
            }
            window.addEventListener("keydown", handleKeyPress);
            window.prevActiveElement = prevActiveElem !== null && prevActiveElem !== void 0 ? prevActiveElem : document.activeElement;
            modalWindow.current.focus();
            if (needAnalyticsOnContentsLink) {
                addAnalyticsForNavigationLinks();
            }
        } else {
            (0,helper.addMavenoidChat)();
            if (!document.getElementsByClassName("show-modal-popup").length) {
                var ref;
                (ref = window.prevActiveElement) === null || ref === void 0 ? void 0 : ref.focus();
                (0,helper.setFocus)(window.keyFocusCallBack);
            }
        }
        (0,helper.preventBodyScroll)(showModal);
        return ()=>{
            window.removeEventListener("keydown", handleKeyPress);
            (0,helper.preventBodyScroll)(false);
        };
    }, [
        showModal
    ]);
    const getNavigationLinksEventInfo = function(link, linkName) {
        let clickInternalLinks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "true";
        var ref;
        const type = window.adobeDataLayer.length > 1 ? window.adobeDataLayer[1]["page"]["category"] : {};
        const eventFor = getEventFor(type);
        const internalLinkType = (type === null || type === void 0 ? void 0 : (ref = type.subCategory1) === null || ref === void 0 ? void 0 : ref.includes("my account:product registration")) ? "my account:navigation" : "".concat(eventFor, ":navigation");
        return JSON.stringify({
            clickInternalLinks,
            eventAction: "".concat(eventFor, ":modal:where do i find my product model number:").concat(linkName),
            eventMsg: "n/a",
            eventName: "".concat(eventFor, ":modal:where do i find my product model number:").concat(linkName),
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: linkName,
            internalLinkPosition: (type === null || type === void 0 ? void 0 : type.subCategoryID) || "contact us",
            internalLinkType,
            internalLinkURL: link,
            internalLinkZoneName: "".concat(eventFor, ":modal:where do i find my product model number")
        });
    };
    const addAnalyticsForNavigationLinks = ()=>{
        setTimeout(()=>{
            modalWindow.current.querySelectorAll(".description p a").forEach((link)=>{
                link.classList.add("gbh-data-layer");
                const textContent = (link === null || link === void 0 ? void 0 : link.textContent) || (link.querySelector("u") ? link.querySelector("u").textContent : "");
                const clickInternalLinks = (textContent === null || textContent === void 0 ? void 0 : textContent.toLowerCase()) === "learn more" ? "true" : "false";
                const eventInfo = getNavigationLinksEventInfo(link.getAttribute("href"), textContent === null || textContent === void 0 ? void 0 : textContent.toLowerCase(), clickInternalLinks);
                link.setAttribute("data-gbh-data-layer", eventInfo);
            });
            modalWindow.current.querySelectorAll(".description h6 a").forEach((link)=>{
                if (link.textContent === "Learn More") {
                    link.classList.add("gbh-data-layer");
                    const eventInfo = getNavigationLinksEventInfo(link.getAttribute("href"), link.textContent.toLowerCase());
                    link.setAttribute("data-gbh-data-layer", eventInfo);
                }
            });
            modalWindow.current.querySelectorAll(".modal-popup-body a").forEach((link)=>{
                if (link.textContent === "Continue") {
                    link.classList.add("gbh-data-layer");
                    link.setAttribute("data-gbh-data-layer", dataLayer);
                }
            });
        }, waitingTImeForModalContentToLoad);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Modal_module_default()).modalWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "modal-popup ".concat(showModal ? "show-modal-popup" : "", " ").concat(className ? className : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "modal-popup-content",
                role: "dialog",
                "aria-modal": true,
                tabIndex: "-1",
                "aria-labelledby": labelledBy,
                "aria-describedby": describedBy,
                ref: modalWindow,
                ...style,
                children: [
                    !hideCloseIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "close-button-holder ".concat(StickCloseButton ? "stick-close-button" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "close-button".concat(closeButtonAnalytics ? " gbh-data-layer" : ""),
                            "data-gbh-data-layer": closeButtonAnalytics,
                            "data-gbh-data-layer-custom": analyticsCustomData || null,
                            onClick: triggerModalClose,
                            tabIndex: "0",
                            role: "button",
                            "aria-label": "Click here to close ".concat(modalTitle, " modal window"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: isWhiteCloseIcon ? close_white/* default */.Z === null || close_white/* default */.Z === void 0 ? void 0 : close_white/* default.src */.Z.src : modal_close/* default */.Z === null || modal_close/* default */.Z === void 0 ? void 0 : modal_close/* default.src */.Z.src,
                                "aria-hidden": true,
                                role: "presentation",
                                alt: "close"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "modal-popup-body",
                        children: isRendered && showModal && children
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Modal_Modal = (Modal);


/***/ }),

/***/ 96352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55760);
/* harmony import */ var _components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78145);
/* harmony import */ var _components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7872);
/* harmony import */ var _components_FindStore_v1_analytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30167);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96301);








const ZipCodeInfoModal = (props)=>{
    const { staticTexts: { infoModalTitle ="" , messageZipcode ="" , continue: continueCtaLabel = ""  } = {} , data: { ctaLabel ="" , title ="" , message =""  } = {} , dataLayerPosition =""  } = props;
    const handleModalClose = (e)=>{
        if (props.data.ctaLink) {
            window.open(props.data.ctaLink);
        } else {
            var ref;
            props.handleModalClose();
            let label = ctaLabel ? ctaLabel : continueCtaLabel;
            if ((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.nodeName) === _constants__WEBPACK_IMPORTED_MODULE_6__.NODE_NAMES.IMG) {
                label = "close";
            }
            (0,_components_FindStore_v1_analytics__WEBPACK_IMPORTED_MODULE_5__/* .zipCodeInfoModalContinueAnalytics */ .CS)(label, dataLayerPosition);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_3__["default"], {
        showModal: props.show,
        className: props.className,
        onModalClose: handleModalClose,
        labelledBy: props.labelledBy,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "taxware-down-title",
                className: "taxware-down__title",
                children: title ? title : infoModalTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "taxware-down__desc",
                children: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__.sanitizeInnerHtml)(message ? message : messageZipcode)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__["default"], {
                tag: "button",
                customClass: "taxware-down__cta",
                role: "button",
                onClick: handleModalClose,
                flexible: true,
                label: ctaLabel ? ctaLabel : continueCtaLabel,
                useDefaultClass: true
            })
        ]
    });
};
_components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_3__["default"].propTypes = {
    labelledBy: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    data: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().object)
};
/* harmony default export */ __webpack_exports__["Z"] = (ZipCodeInfoModal);


/***/ }),

/***/ 43106:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"Modal_modalWrapper__asWMh"};

/***/ })

}]);